import { veerChandActivities } from "../../config/homePageUtils";
import Section from "./Section";

const ActivitiesSection = ({ language }) => {
  return (
    <Section
      id="activities-section"
      title={language ? "योजना के तहत गतिविधियां" : "Activities Covered Under the Scheme"}
      spaceY4Needed={false}
    >
      <div className="overflow-x-auto my-4">
        <table className="min-w-full border border-gray-300 text-sm text-left">
          <thead>
            <tr className="bg-white">
              <th className="border border-gray-300 px-4 py-2 font-semibold text-gray-700">
                {language ? "क्रमांक" : "Sr. No"}
              </th>
              <th className="border border-gray-300 px-4 py-2 font-semibold text-gray-700">
                {language ? "परिवहन आधारित गतिविधियां (वाहन)" : "Transport-based Activities (Vehicles)"}
              </th>
              <th className="border border-gray-300 px-4 py-2 font-semibold text-gray-700">
                {language ? "गैर-परिवहन गतिविधियां (इंफ्रास्ट्रक्चर और सेवाएं)" : "Non-transport Activities (Infrastructure and Services)"}
              </th>
            </tr>
          </thead>

          <tbody>
            {veerChandActivities.map((item, idx) => (
              <tr key={idx} className="bg-white align-top">
                <td className="border border-gray-300 px-4 py-2">{item.srNo}</td>

                <td className="border border-gray-300 px-4 py-2">
                  <ul className="list-disc list-inside space-y-1">
                    {item.transport.map((act, i) => (
                      <li key={i}>{language ? act.hi : act.en}</li>
                    ))}
                  </ul>
                </td>

                <td className="border border-gray-300 px-4 py-2">
                  <ul className="list-disc list-inside space-y-1">
                    {item.nonTransport.map((act, i) => (
                      <li key={i}>{language ? act.hi : act.en}</li>
                    ))}
                  </ul>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Section>
  );
};

export default ActivitiesSection;
